import { Box, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => (
	<CssColumnGrid columns={3}>
		<Text semiBold text="normal" />
		<Text semiBold text="block" />
		<Text semiBold text="grow" />
		<Box
			border={STANDARD_BORDER_STYLE}
			display="inline-block"
			padding={2}
			textAlign="left"
			width={200}
		>
			<Text text="The quick brown fox jumps " />
			<Text text="over the lazy dog!" />
		</Box>
		<Box
			border={STANDARD_BORDER_STYLE}
			display="inline-block"
			padding={2}
			textAlign="left"
			width={200}
		>
			<Text block text="The quick brown fox jumps" />
			<Text text="over the lazy dog!" />
		</Box>
		<Box
			border={STANDARD_BORDER_STYLE}
			display="inline-flex"
			padding={2}
			width={200}
		>
			<Text text="Start" />
			<Text grow text="Middle" />
			<Text text=" End" />
		</Box>
	</CssColumnGrid>
);
